import React from 'react';
import { AdvancedImage, responsive } from '@cloudinary/react';
import { RichLink } from '@naf-simba/sections-rich-link';
import { useDispatch } from 'react-redux';
import { DEFAULT_IMG_PUBLIC_ID } from '@lib/constants';
import { getMediaProps } from './utils/getMediaProps';
import { InternalSearchResultType } from '../../hooks/GlobalSearchTypes';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';
import { useResolveLink } from '../../hooks/useResolveLink';
import { actions } from '../../redux/modules/user';
import { enableScroll } from '../../hooks/useScrollBlock';
import { useTrackSearchResultClick } from '../../hooks/useTrackSearchResultClick';

interface Props {
  item: InternalSearchResultType;
}
export const SimpleResultCard = ({ item }: Props) => {
  const href = item.url?.raw;
  const title = item.naf_page_title?.raw || '';

  const { getResponsiveImage } = useCloudinary();
  const { isInternal, linkProps } = useResolveLink(href);
  const { trackClickSearchResult } = useTrackSearchResultClick();

  const text = item.naf_page_description?.raw || item.body_content?.raw;

  const cldImage = item.naf_image_publicid?.raw
    ? getResponsiveImage(item.naf_image_publicid.raw)
    : getResponsiveImage(DEFAULT_IMG_PUBLIC_ID);

  const advancedImage = cldImage ? (
    <AdvancedImage cldImg={cldImage} plugins={[responsive({ steps: 200 })]} />
  ) : undefined;

  const media = getMediaProps(advancedImage);

  const dispatch = useDispatch();
  const handleOnClick = () => {
    trackClickSearchResult();
    dispatch(actions.closeMenu());
    enableScroll();
  };

  const description = text || undefined;

  if (isInternal && linkProps.to) {
    return (
      <li key={item.id.raw}>
        <RichLink
          to={linkProps.to}
          title={title}
          description={description}
          media={media}
          variant="standard"
          onClick={handleOnClick}
        />
      </li>
    );
  }

  if (href) {
    return (
      <li key={item.id.raw}>
        <RichLink href={href} title={title} description={description} media={media} variant="standard" />
      </li>
    );
  }

  return null;
};
